import React, { useContext } from "react";
import ProcessCard from "../../../components/Cards";
import { fontstyle1 } from "../../../utils/fonts";
import Process1 from "../../../assets/process1.png";
import Process2 from "../../../assets/process2.png";
import ThemeContext from "../../../context";

const ProcessFlow = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <div className="w-full h-full p-5 mt-5">
      <div className=" flex items-center justify-between">
        <div className="flex flex-col items-center sm:items-start">
          <p style={fontstyle1} className="text-2xl">
            The process to follow
          </p>
          <div className="flex flex-col sm:flex-row gap-20 mt-10">
            <ProcessCard
              id="1."
              name="Creating account"
              desc="create account with"
              bolddesc="dofeedbackin"
              link="#"
            />
            <ProcessCard
              id="2."
              name="Creating Project"
              desc="create project by clicking"
              bolddesc="Add New Project"
              link="#"
            />
          </div>
          <div className="flex gap-20  flex-col sm:flex-row mt-16">
            <ProcessCard
              id="3."
              name="Creating web project"
              desc="Create your own web project with any framework which has some kind of form in it."
              bolddesc=""
              link="#"
            />
            <ProcessCard
              id="4."
              name="Attach the api key"
              desc='"Get the api key and attach your url+key to your web project. For more information read this '
              bolddesc="Article"
              link="https://aravindkumarvemula.medium.com/signup-for-dofeedbackin-3be8c422b74b"
            />
          </div>
        </div>
        <div>
          {theme === "light" ? (
            <img
              src={Process1}
              alt="Process2"
              className="w-80 hidden sm:hidden md:block"
            />
          ) : (
            <img
              src={Process2}
              alt="process2"
              className="w-80 hidden sm:hidden md:block"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessFlow;
